<template>
	<div class="details-layout">
		<div class="details-header">
			<SkeletonBar class="details-header-skeleton" v-if="loading" />
			<div class="details-header-icon" v-if="!loading && $slots['header-icon']">
				<slot name="header-icon" />
			</div>
			<div class="details-header-content">
				<slot name="super-title">
					<div class="super-title" v-text="superTitle" v-if="!loading" />
				</slot>
				<slot name="title">
					<h1
						class="details-title"
						v-text="title"
						v-if="!loading"
						:title="title"
						:class="{ 'no-super-title': !superTitle }"
					/>
				</slot>
			</div>
		</div>
		<div class="details-content">
			<slot name="content">
				<div class="details-content-top">
					<slot name="content-top">
						{{ label }}
						<Button
							v-bind="buttonProps"
							primary
							@click="$emit('click', $event)"
						>
							{{ buttonText }}
						</Button>
					</slot>
				</div>
				<slot name="search">
					<Input
						v-model="query"
						class="search-bar"
						:placeholder="placeholder"
						:icon="SearchIcon"
						:iconProps="{ type: 'regular' }"
						allowClear
					/>
				</slot>
			</slot>
		</div>
		<div class="details-table">
			<slot name="table" />
		</div>
		<div class="details-sidebar">
			<slot name="sidebar" />
		</div>
	</div>
</template>

<script>
import { Button, Input, SkeletonBar } from '@/components/common'
import { SearchIcon } from '@/icons'
import SidebarSection from './SidebarSection'
import { markRaw } from 'vue'

export { SidebarSection }

export default {
	name: 'DetailsLayout',
	components: { Button, Input, SkeletonBar },
	props: {
		superTitle: String,
		title: String,
		label: String,
		defaultSearch: String,
		placeholder: String,
		buttonText: String,
		buttonProps: Object,
		loading: { type: Boolean, default: null },
	},
	data() {
		return {
			SearchIcon: markRaw(SearchIcon),
			query: this.defaultSearch || null,
		}
	},
	emits: ['click', 'search'],
	watch: {
		query(q) {
			this.$emit('search', q)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.details-layout {
	display: grid;
	grid-template-columns: auto 240px;
	grid-template-rows: 125px 135px auto;
	grid-template-areas:
		'header header'
		'content sidebar'
		'table sidebar' !important;
	height: 100vh;
	width: 100%;
	background: #fafafa;
	.details-header {
		grid-area: header;
		@include flex(16px);
		padding: 0 24px;
		border-bottom: 1px solid var(--neutral-200);
		.details-header-icon {
			font-size: 56px;
		}
		.details-header-content {
			@include flex-column;
			justify-content: center;
			> .details-title {
				font-size: 36px;
				color: var(--neutral-800);
				font-family: Avenir-Heavy;
				margin: 0;
				@include clamp(2);
			}
			> .super-title {
				font-size: 12px;
				font-family: Avenir-Roman;
				color: var(--neutral-800);
				@include clamp(1);
			}
		}
	}
	.details-content {
		grid-area: content;
		padding: 8px 24px;
		@include flex-column;
		justify-content: center;
		.search-bar {
			width: 100%;
			background: white;
		}
		.details-content-top {
			font-size: 24px;
			font-family: Avenir-Heavy;
			margin-bottom: 16px;
			.pronto-btn {
				margin-left: 16px;
			}
		}
	}
	.details-table {
		grid-area: table;
	}
	.details-sidebar {
		grid-area: sidebar;
		border-left: 1px solid var(--neutral-200);
		overflow-y: auto;
	}
	.details-header-skeleton {
		margin-top: 16px;
		width: 100%;
		max-width: 500px;
		height: 40px;
	}
	.no-super-title {
		margin: 16px 0 0 0;
	}
}
</style>
